import LoggerService from "@bfx/logger";
import { Subject, concatMap } from "rxjs";

const logger = LoggerService.for(__dirname);

export class ResizeObserverScheduler extends ResizeObserver {
  protected scheduleSubject: Subject<{ entries: ResizeObserverEntry[]; observer: ResizeObserver }> =
    new Subject();

  constructor(
    callback: (
      entries: Array<ResizeObserverEntry>,
      observer: ResizeObserver,
    ) => Promise<void> | void,
    protected source: string,
  ) {
    super((entries, observer) => this.scheduleCallback(entries, observer));

    this.scheduleSubject
      .pipe(
        concatMap(({ entries, observer }) => {
          return new Promise<void>((res) => {
            Promise.resolve(callback(entries, observer)).then(() => res());
          });
        }),
      )
      .subscribe({
        next: () => {
          logger.out.info(`${this.constructor.name} callback() for ${source} executed.`);
        },
        complete: () => {
          this.disconnect();
          logger.out.info(
            `${this.constructor.name} ResizeObserver disconnect() and callback() scheduling for ${source} completed.`,
          );
        },
      });
  }

  protected scheduleCallback(entries: ResizeObserverEntry[], observer): void {
    if (!Array.isArray(entries) || !entries.length) {
      logger.out.error(
        `${this.constructor.name}: bailing out of scheduleCallback() for ${this.source} due to no entries %O`,
        entries,
      );
      return;
    }

    setTimeout(() => {
      this.scheduleSubject.next({ entries, observer });
    }, 0);
  }

  public complete() {
    this.scheduleSubject.complete();
  }
}
